// extracted by mini-css-extract-plugin
export var itemText = "Schedule-module--itemText--VjLqU";
export var itemTime = "Schedule-module--itemTime--xa7x+";
export var root = "Schedule-module--root--KIzf7";
export var schedule = "Schedule-module--schedule--CBoV5";
export var scheduleItem = "Schedule-module--scheduleItem--7prjN";
export var scheduleList = "Schedule-module--scheduleList--02lM2";
export var subtitle = "Schedule-module--subtitle--dFYRV";
export var title = "Schedule-module--title--V7qiw";